angular.module('impactx.approval').directive('ixApprovalGroup', function () {
    return {
        restrict: 'E',
        scope: {
            group: "=",
            isFirstEntry: "=",
            isLastEntry: "=",
            onlyOneEntry: "=",
            redirectLabel: '@?',
            redirectFunction: '&?',
            canRedirectAny: '=?',
            representedByLabel: "@"
        },
        controller: 'ApprovalGroupCtrl',
        controllerAs: 'approvalGroupCtrl',
        templateUrl: 'shared/approval/templates/approval-group.tmpl.html'
    }
});